const ExploreBrandsSection = () => {
  return (
    <div className="section-full twm-explore-section-wrap site-bg-primary">
      <div className="container">
        <div className="row">

          {/* Title */}
          <div className="col-xl-4 col-lg-12">
            <div className="section-head left">
              <div className="twm-sm-title left site-text-white text-dark">
                Garud Cab Services
              </div>

              <h2 className="twm-large-title site-text-white text-dark">
                Explore Our Reliable Cab Services
              </h2>
            </div>
          </div>

          {/* Cab Image */}
          <div className="col-xl-6 col-lg-12">
            <div className="twm-mid-section-car">
              {/* <div className="twm-media">
                <img
                  src="/images/explore-sec-image.jpeg"
                  alt="Garud Cab Service Pune"
                />
              </div> */}
              <div className="twm-media explore-media">
    <img
        src="/images/explore-sec-image.jpg"
        alt="Garud Cab Service Pune"
    />
</div>

            </div>
          </div>

          {/* Button */}
          <div className="col-xl-2 col-lg-12">
            <div className="twm-mid-section-btn">
              <a href="/services" className="site-button">
                <em>View Services</em>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ExploreBrandsSection;
